module.exports = __webpack_public_path__ + "static/img/rank_101.0b17915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_101.png
// module id = Ih/6
// module chunks = 1